import { Component, input } from '@angular/core';

import { CamTranslationCore } from '@camelot/core';
import { ColorType } from '@camelot/styles';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { ItemType } from '../../../../common/services/dto/item-type';

@Component({
  selector: 'cam-billings-item-type-status',
  templateUrl: './item-type-status.component.html',
  styleUrl: './item-type-status.component.scss',
  imports: [TranslatePipe, BadgeComponent],
})
export class ItemTypeStatusComponent extends CamBaseComponent {
  type = input.required<ItemType>();

  get show() {
    return this.type() !== ItemType.Normal && this.type() !== ItemType.Unknown;
  }
  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public getType(): ColorType {
    switch (this.type()) {
      case ItemType.Reduction:
        return 'success';
      case ItemType.Options:
        return 'warning';
      default:
        return 'default';
    }
  }

  public getTranslate() {
    return `core.types.${ItemType[this.type()]?.toLowerCase() ?? 'unknown'}`;
  }
}
